import React, { forwardRef } from "react";

const MAX_LENGTH = 1;

interface DigitPropsI {
	id: string;
	value?: string;
	placeholder?: string;
	autoFocus?: boolean;
	onTextChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => void;
	onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const Digit = forwardRef<HTMLInputElement, DigitPropsI>((props, ref) => {
	return (
		<div className="form-input">
			<input
				ref={ref}
				onChange={(e) => {
					const value = e.target.value;
					if (/^\d+$/.test(value)) {
						if (value) {
							props.onTextChange(e);
						}
					}
				}}
				data-automationid={`digit-input-${props.id}`}
				data-testid={`digit-input-${props.id}`}
				onPaste={props.onPaste}
				onKeyDown={props.onKeyDown}
				value={props.value}
				className="field"
				id={props.id}
				name={props.id}
				placeholder={props?.placeholder}
				type="tel"
				autoComplete="one-time-code"
				autoFocus={props?.autoFocus}
				maxLength={MAX_LENGTH}
			/>
		</div>
	);
});
